// /src/store/networkManagment/reducer.ts

import { FETCH_ALL_IPS_DETAILS_REQUEST ,
         FETCH_ALL_IPS_DETAILS_SUCCESS ,
         FETCH_ALL_IPS_DETAILS_FAILURE ,
         FETCH_ONE_IP_DETAILS_REQUEST  ,
         FETCH_ONE_IP_DETAILS_SUCCESS  ,
         FETCH_ONE_IP_DETAILS_FAILURE  ,
         NetworkState                  ,
         initialState                  ,
         NetworkActionTypes            } from './types';

const networkInformationsReducer = (state = initialState, action: NetworkActionTypes): NetworkState => {

  switch (action.type)
   {
    case FETCH_ONE_IP_DETAILS_REQUEST  :
    case FETCH_ALL_IPS_DETAILS_REQUEST : return {
                                                  ...state,
                                                  loading : true,
                                                  error   : null,
                                                };

    case FETCH_ONE_IP_DETAILS_SUCCESS  : return {
                                                  ...state,
                                                  loading            : false,
                                                  ipDetails          : new Map(state.ipDetails).set(action.payload.ipAddress, action.payload),
                                                  lastFetchTimestamp : Date.now(),
                                                };

    case FETCH_ALL_IPS_DETAILS_SUCCESS : const ipDetailsMap = new Map(state.ipDetails);
                                         action.payload.forEach(ipDetail => { ipDetailsMap.set(ipDetail.ipAddress, ipDetail); });

                                         return {
                                                  ...state,
                                                  loading            : false,
                                                  ipDetails          : ipDetailsMap,
                                                  lastFetchTimestamp : Date.now(),
                                                };

    case FETCH_ONE_IP_DETAILS_FAILURE  :
    case FETCH_ALL_IPS_DETAILS_FAILURE : return {
                                                  ...state,
                                                  loading : false,
                                                  error   : action.payload,
                                                };

    default                            : return state;
  }
};

export default networkInformationsReducer;
